import React, { useState, useEffect } from "react";

import { HashRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline, useMediaQuery } from "@mui/material";

import { lightTheme, darkTheme } from "./theme/theme";

import Header from "./components/header";
import Quiz from "./components/quiz";

function App() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [darkMode, setDarkMode] = useState(() => {
    const storedTheme = sessionStorage.getItem("darkMode");
    if (storedTheme !== null) {
      return storedTheme === "true";
    }
    return prefersDarkMode;
  });

  useEffect(() => {
    sessionStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  const handleThemeToggle = () => {
    setDarkMode(!darkMode);
    sessionStorage.setItem("darkMode", !darkMode);
  };

  localStorage.setItem("SM_SCREEN", "600px");
  localStorage.setItem("MD_SCREEN", "900px");
  localStorage.setItem("LG_SCREEN", "1200px");
  localStorage.setItem("XL_SCREEN", "1536px");

  return (
    <HashRouter>
      <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <CssBaseline />
        <Header darkMode={darkMode} handleThemeToggle={handleThemeToggle} />
        <Routes>
          <Route path="*" element={<Quiz />} />
        </Routes>
      </ThemeProvider>
    </HashRouter>
  );
}

export default App;
